import React, { useEffect, useState } from 'react';
import './App.css';
import InvoicePortal from './components/InvoicePortal';
import { initializeAuth } from './utils/authService';

function App() {
  const [isAuthInitialized, setIsAuthInitialized] = useState(false);
  const [authError, setAuthError] = useState(null);

  useEffect(() => {
    // Initialize authentication when app starts
    const initAuth = async () => {
      console.log('Initializing API authentication...');
      const result = await initializeAuth();
      
      if (result.success) {
        console.log('API authentication successful');
        setIsAuthInitialized(true);
      } else {
        console.error('API authentication failed:', result.error);
        setAuthError(result.error);
        // Still set initialized to true to allow app to load
        // The authenticatedFetch will retry auth on first request
        setIsAuthInitialized(true);
      }
    };
    
    initAuth();
  }, []);

  // Show loading state while authenticating
  if (!isAuthInitialized) {
    return (
      <div className="App">
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '100vh',
          flexDirection: 'column' 
        }}>
          <p>Inicializando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {authError && (
        <div style={{ 
          backgroundColor: '#fff3cd', 
          border: '1px solid #ffc107',
          color: '#856404',
          padding: '10px',
          margin: '10px',
          borderRadius: '4px'
        }}>
          Advertencia: {authError}. La autenticación se reintentará automáticamente.
        </div>
      )}
      <InvoicePortal />
    </div>
  );
}

export default App;
